const firebaseConfig = {
    apiKey: "AIzaSyBxFd1e7C-UyFx42c-VzPaTBOUcZANIPxs",
    authDomain: "portfolio-chat-e9857.firebaseapp.com",
    databaseURL: "https://portfolio-chat-e9857.firebaseio.com",
    projectId: "portfolio-chat-e9857",
    storageBucket: "portfolio-chat-e9857.appspot.com",
    messagingSenderId: "747179303041",
    appId: "1:747179303041:web:a4e3d3f8db054a0d96ad80",
    measurementId: "G-NZ7NGG82TB"
  };

export default firebaseConfig;